module.exports = __webpack_public_path__ + "static/media/credit_mastercard_gold.9a59f770.svg";